module.exports = __webpack_public_path__ + "media/theme/tutorial__reco--3--create-df674a18.png";